import React from "react"
import { Typography } from "@mui/material"


export default function timeColumn() {
	return {
		name: 'Time from & to',
		render: (_, row) => <Typography sx={{ fontSize: 13 }}>{`From ${row.timeFrom} to ${row.timeTo}`}</Typography>
	}
}